import React from 'react';
import '../styles/Header.css';
import { Link } from "react-router-dom";


const Header = ({ currentDate, currentTime }) => {
  return (
    <header className="billing-header">
      <div className="header-left">
        <h1 className="company-name">Cake Shop</h1>
        <p className="tagline">Sale System</p>
      </div>
      <div className="header-right">
        <div className="datetime-display">
          <span className="current-date">{currentDate}</span>
          <span className="current-time">{currentTime}</span>
        </div>
        <div className="user-greeting">
          <span className="greeting-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
              <path fillRule="evenodd" d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z" clipRule="evenodd" />
            </svg>
          </span>
          <span className="greeting-text">Hello, Cashier</span>
          <Link to="/admin" className="admin-link">Admin Panel</Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
